// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Single Video */

.tooltips {
  position: relative;
  display: inline-block;
}

.tooltips .tooltiptext {
  visibility: hidden;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  left: 137px;
  position: absolute;
  top: -168px;
  height: 257px;
  z-index: 1200;
  color: white;
}

.member-view-box {
  text-align: center;
  border-radius: 2px;
  position: relative;
}

.member-image {
  /* width: 100px; */
  position: relative;
  z-index: 10;
  width: 150px;
}

.member-image:hover {
  transform: scale(1.05);
  transition: 0.3s;
}

.member-image img {
  height: 73px;
  border-radius: 6px;
  background-color: #000;
  z-index: 1;
  border: 2px solid black;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  object-fit: fill;
}

.img-fluid {
  max-width: none !important;
}

.viwedVideo {
  border: 3px solid green;
}

.child-name {
  background: #e6e6e6;
  color: black;
  font-size: 12px;
  margin: 0 auto;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #9a9a9a;
  padding: 0 2px;
  white-space: initial;
  word-break: break-word;
  line-height: 1.5;
}

.selected-video {
  background: #4cec5a;
  color: white;
}

.comment-count {
  position: absolute;
  top: 0px;
  font-size: 18px;
  color: #d2ba45;
  width: 28px;
  height: 28px;
  right: 0px;
  border: 1px solid #d2ba45;
  background-color: white;
}

.fa-infos {
  font-size: 22px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: white;
  padding: 14px;
  height: 28px;
  width: 28px;
}

.fa-infos img {
  background: none !important;
  height: 28px !important;
  border: none !important;
  background: white !important;
  padding: 2px !important;
  width: 28px !important;
  position: absolute !important;
  left: 0;
  top: 0;
}

.question-view {
  font-size: 22px;
  position: absolute !important;
  left: 0px;
  top: -2px;
  color: #ba65cc;
  background: #ffffff;
  padding: 6px;
  /* border-radius: 50%; */
  width: 32px;
  height: 32px;
}

.lock-position {
  /* position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  width: 100%; */
      position: absolute;
        top: 35px;
        right: 5px;
        z-index: 99;
        width: 35px;
        height: 35px;
}

.fa-check {
  color: green;
  font-size: 25px;
  z-index: 150;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/video-tree/single-video/single-video.component.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,OAAO;EACP,MAAM;AACR;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;;;;gBAIc;MACV,kBAAkB;QAChB,SAAS;QACT,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":["/* Single Video */\n\n.tooltips {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltips .tooltiptext {\n  visibility: hidden;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  left: 137px;\n  position: absolute;\n  top: -168px;\n  height: 257px;\n  z-index: 1200;\n  color: white;\n}\n\n.member-view-box {\n  text-align: center;\n  border-radius: 2px;\n  position: relative;\n}\n\n.member-image {\n  /* width: 100px; */\n  position: relative;\n  z-index: 10;\n  width: 150px;\n}\n\n.member-image:hover {\n  transform: scale(1.05);\n  transition: 0.3s;\n}\n\n.member-image img {\n  height: 73px;\n  border-radius: 6px;\n  background-color: #000;\n  z-index: 1;\n  border: 2px solid black;\n  width: 100%;\n  border-radius: 4px 4px 0px 0px;\n  object-fit: fill;\n}\n\n.img-fluid {\n  max-width: none !important;\n}\n\n.viwedVideo {\n  border: 3px solid green;\n}\n\n.child-name {\n  background: #e6e6e6;\n  color: black;\n  font-size: 12px;\n  margin: 0 auto;\n  border-radius: 0px 0px 4px 4px;\n  border: 1px solid #9a9a9a;\n  padding: 0 2px;\n  white-space: initial;\n  word-break: break-word;\n  line-height: 1.5;\n}\n\n.selected-video {\n  background: #4cec5a;\n  color: white;\n}\n\n.comment-count {\n  position: absolute;\n  top: 0px;\n  font-size: 18px;\n  color: #d2ba45;\n  width: 28px;\n  height: 28px;\n  right: 0px;\n  border: 1px solid #d2ba45;\n  background-color: white;\n}\n\n.fa-infos {\n  font-size: 22px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  background: white;\n  padding: 14px;\n  height: 28px;\n  width: 28px;\n}\n\n.fa-infos img {\n  background: none !important;\n  height: 28px !important;\n  border: none !important;\n  background: white !important;\n  padding: 2px !important;\n  width: 28px !important;\n  position: absolute !important;\n  left: 0;\n  top: 0;\n}\n\n.question-view {\n  font-size: 22px;\n  position: absolute !important;\n  left: 0px;\n  top: -2px;\n  color: #ba65cc;\n  background: #ffffff;\n  padding: 6px;\n  /* border-radius: 50%; */\n  width: 32px;\n  height: 32px;\n}\n\n.lock-position {\n  /* position: absolute;\n  top: 30%;\n  left: 0;\n  right: 0;\n  width: 100%; */\n      position: absolute;\n        top: 35px;\n        right: 5px;\n        z-index: 99;\n        width: 35px;\n        height: 35px;\n}\n\n.fa-check {\n  color: green;\n  font-size: 25px;\n  z-index: 150;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
